// src/components/Footer.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ADMIN_EMAIL } from '../services/auth';
import { LEGAL_DETAILS } from '../config/legal';
import fateRoomLogo from '../assets/images/fate-room-logo.svg';
import { useI18n } from '../i18n/I18nContext';
import LanguageSelector from './LanguageSelector';
import '../style/Footer.css';

const Footer = () => {
  const { user, userType } = useContext(AuthContext);
  const { t } = useI18n();
  const isAdmin = userType === 'admin'
    || String(user?.email || '').trim().toLowerCase() === ADMIN_EMAIL;
  const dashboardPath = userType === 'teller' ? '/teller-dashboard' : '/user-dashboard';
  const groups = [
    { title: t('footer.use'), links: [[t('footer.open'), '/login'], [t('footer.how'), '/how-it-works'], [t('footer.gift'), '/gift'], [t('footer.redeem'), '/redeem'], [t('footer.pro'), '/subscribe'], [t('footer.content'), '/content-library']] },
    { title: t('footer.company'), links: [[t('footer.about'), '/about'], [t('footer.leadership'), '/leadership'], [t('footer.press'), '/press'], [t('footer.partnership'), '/partnership'], [t('footer.sitemap'), '/sitemap']] },
    { title: t('footer.support'), links: [[t('footer.help'), '/help'], [t('footer.contact'), '/contact'], [t('footer.mental'), '/mental-health'], [t('footer.accessibility'), '/accessibility'], [t('footer.security'), '/security'], [t('footer.cookies'), '/cookie-policy'], [t('footer.google'), '/account-and-google-privacy']] },
    { title: t('footer.legal'), links: [[t('footer.terms'), '/terms'], [t('footer.privacy'), '/privacy'], [t('footer.health'), '/health-data'], [t('footer.sharing'), '/sharing-settings'], [t('footer.operator'), '/legal-notice']] },
  ];
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo" aria-label={t('a11y.home')}>
            <img src={fateRoomLogo} alt="Fate Room" className="fate-room-logo" />
          </Link>
          <p>
            {t('footer.description')}
          </p>
          <LanguageSelector />
          <p className="footer-language-note">{t('support.englishOnly')}</p>
          <div className="store-row">
            {user ? (
              <>
                {!isAdmin && <Link to={dashboardPath} className="store-button">{t('nav.dashboard')}</Link>}
                <Link to="/logout" className="store-button">{t('nav.logout')}</Link>
              </>
            ) : (
              <>
                <Link to="/login" className="store-button">{t('nav.login')}</Link>
                <Link to="/register" className="store-button">{t('nav.create')}</Link>
              </>
            )}
          </div>
        </div>

        {groups.map((group) => (
          <div className="footer-section" key={group.title}>
            <h3>{group.title}</h3>
            <ul>
              {group.links.map(([label, href]) => (
                <li key={href}>
                  <Link to={href}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="footer-bottom">
        <div className="footer-operator">
          <p>
            <strong>{LEGAL_DETAILS.brandName}</strong> · {t('footer.soleTrader')}.
          </p>
        </div>
        <div className="footer-disclaimer">
          <p>{t('footer.copyright')}</p>
          <p>{t('footer.disclaimer')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
